
/**
 * 
 * @param {*} search 
 * @param {*} params 
 * @param {*} enumConfigList: pozycja listy wygląda tak: 
 *    {
 *      name: 'PaymentMethod', // nazwa enumu
 *      values: [{key: 'CARD', value: t('PaymentMethod.CARD')}, {key: 'CASH', value: t('PaymentMethod.CASH')}] // lista wartości enumu z tłumaczeniami
 *    }
 */
export const prepareEnumSearchParams = (search, params, enumConfigList) => {
    if (search && search.length > 0) {
        const query = search.toLowerCase();

        const searchEnum = enumConfigList?.map(enumConfig => {
            const values = enumConfig.values;
            const name = enumConfig.name;
            return values.filter(v => v.value.toLowerCase().includes(query)).map(v => name + '-' + v.key).join(':');
        }).join(':');
        if (searchEnum.length > 0) {
            params.append('search_enum', searchEnum);
        }
    }
}
